import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";

import Loader from "./common/Loader";
import PageTitle from "./components/PageTitle";
import SignIn from "./pages/Authentication/SignIn";
import useAuth from "./hooks/useAuth.tsx";
import TeahersDashboard from "./pages/TeahersDashboard.tsx";
import Protocols from "./pages/Protocols.tsx";
import Protocol from "./pages/Protocol.tsx";
import Schedule from "./pages/Schedule.tsx";
import StudentsList from "./pages/StudentsList.tsx";
import { Toaster } from "react-hot-toast";

function App() {
  const [loading, setLoading] = useState<boolean>(true);
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (isAuthenticated !== undefined) {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    console.log("isAuthenticated:", isAuthenticated);
    console.log("pathname:", pathname);
    if (isAuthenticated === undefined) {
      return;
    }
    if (!isAuthenticated && !pathname.includes("/auth")) {
      navigate("/auth/signin");
    } else if (isAuthenticated && pathname.includes("/auth")) {
      navigate("/");
    }
  }, [isAuthenticated, pathname, navigate]);

  // @ts-ignore
  return loading ? (
    <Loader />
  ) : (
    <>
      <Toaster position="bottom-right" reverseOrder={false} toastOptions={{
        duration: 6000,
        style: {
          borderRadius: '4px',
          background: '#333',
          color: '#fff',
          padding: '16px',
        },
      }} />

      <Routes>
        {isAuthenticated ? (
          <>
            <Route
              index
              element={
                <>
                  <PageTitle title="Преподавателски портал" />
                  <Schedule />
                </>
              }
            />
            <Route
              path="/protocols" // Route for the ProtocolsTable
              element={
                <>
                  <PageTitle title="Преподавателски портал" />
                  <Protocols />
                </>
              }
            />
            <Route
              path="/protocol/:id" // Dynamic route for protocols
              element={
                <>
                  <PageTitle title="Преподавателски портал" />
                  <Protocol />
                </>
              }
            />
            <Route
              path="/students-list"
              element={
                <>
                  <PageTitle title="Преподавателски портал" />
                  <StudentsList />
                </>
              }
            />
          </>
        ) : (
          <>
            <Route
              path="/auth/signin"
              element={
                <>
                  <PageTitle title="Преподавателски портал" />
                  <SignIn />
                </>
              }
            />
          </>
        )}
      </Routes>
    </>
  );
}

export default App;
